<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>

        <paginated-table v-else :data="news" :columns="tableColumns" :title="$t('title.membernews_list')"
          @updatePagination="updatePagination">

          <template v-slot:top-buttons>
            <custom-button @click="toEditMembernews" :label="$t('button.add')" color="primary" size="lg" gradient
              rounded></custom-button>
          </template>

        </paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { getMemberNewsColumns } from "@/views/BoardView/columns";

import { boardApi } from "@/api/api";

export default {
  components: {
    PaginatedTable,
    CustomButton,
    LoadingSpinner,
  },
  data() {
    return {
      // fields & columns 
      tableColumns: getMemberNewsColumns({
        description: this.handleShowDescription,
      }),

      // boolean
      isLoading: false,

      // init data
      boardIdx: 2,
      news: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
    }
  },
  methods: {
    /**
     * *******************************************************************************************
     *  버튼 액션
     * *******************************************************************************************
     */
    toEditMembernews() {
      const type = this.$store.getters['auth/userType'] || null;

      if (['R', 'A'].includes(type)) {
        this.$router.push("/posts/membernews/edit");
        return true;
      };

      this.notifyVue({
        message: this.$t('alert.no_permission_article'),
        style: "danger",
      });
      return false;
    },
    async handleShowDescription(post) {
      this.$router.push({
        name: 'membernews-detail',
        params: {
          idx: post.idx,
        }
      })
    },
    /**
     * *******************************************************************************************
     *  API 요청
     * *******************************************************************************************
     */

    // 목록 조회
    async fetchPosts() {
      const params = {
        board_idx: this.boardIdx,
        size: this.news.page_info.size,
        page: this.news.page_info.page,
      }
      this.isLoading = true;

      try {
        const response = await boardApi.getPosts(params);

        if (response && response.status === 200) {
          this.news = response.data.response;
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t('alert.failed_request'),
          style: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * *******************************************************************************************
     *  기타 메서드
     * *******************************************************************************************
     */

    /**
     * Pagination 타입 명세
     * @typedef {Object} Conditions
     * @property {string} page - 페이지
     * @property {string} size - 사이즈
     * @property {string} total_elements - 전체 데이터 수 
     * @property {string} total_pages - 전체 페이지 수
     */

    /** 
     * 페이지네이션 업데이트 메서드
     *  
     * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
     * @params {Pagination} pagination
     */
    updatePagination(pagination) {
      this.news.page_info.size = pagination.size;
      this.news.page_info.page = pagination.page;

      this.fetchPosts();
    },

    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    }
  },
  mounted() {
    this.fetchPosts();
  },
};
</script>

<style lang="css" scoped>
.right-button {
  display: flex;
  justify-self: flex-end;
  margin-right: 20px;
  margin-bottom: -15px;
}
</style>